"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortWeavesById = sortWeavesById;
exports.sortDocumentsByCreated = sortDocumentsByCreated;
exports.sortDocumentsByTitle = sortDocumentsByTitle;
const dates_1 = require("../dates");
/**
 * Sorts an array of weaves by their ID.
 */
function sortWeavesById(weaves, ascending = true) {
    return [...weaves].sort((a, b) => ascending ? a.id.localeCompare(b.id) : b.id.localeCompare(a.id));
}
/**
 * Sorts an array of documents by their creation date.
 */
function sortDocumentsByCreated(docs, ascending = true) {
    return [...docs].sort((a, b) => ascending ? (0, dates_1.compareDates)(a.created, b.created) : (0, dates_1.compareDates)(b.created, a.created));
}
/**
 * Sorts an array of documents by their title.
 */
function sortDocumentsByTitle(docs, ascending = true) {
    return [...docs].sort((a, b) => ascending ? a.title.localeCompare(b.title) : b.title.localeCompare(a.title));
}
